import { render, staticRenderFns } from "./SystemEndPointList.vue?vue&type=template&id=149d34a4"
import script from "./SystemEndPointList.vue?vue&type=script&lang=js"
export * from "./SystemEndPointList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports